export default [
    {
        path: '/bank', // 浙商银行 
        component: resolve => require(['@/pages/thirdparty/bank'], resolve),
        meta: { title: "浙商银行长龙航空联名卡" }
    },
    {
        path: '/alipaycard', //  支付宝
        component: resolve => require(['@/pages/thirdparty/alipaycard'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/alipaycardAuth', //  支付宝
        component: resolve => require(['@/pages/thirdparty/alipaycardAuth'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/isLogin',
        component: resolve => require(['@/pages/thirdparty/islogins'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/payResult', //  支付结果页
        component: resolve => require(['@/pages/thirdparty/payResult'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/payFoodResult', //  美食支付结果页
        component: resolve => require(['@/pages/thirdparty/payFoodResult'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/download', //  美食支付结果页
        component: resolve => require(['@/pages/thirdparty/download'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/appdownload', //  app下载页
        component: resolve => require(['@/pages/thirdparty/appdownload'], resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/thirdParty.js